import React from 'react';

import { FiDatabase } from 'react-icons/fi';
import { withTranslation } from 'react-i18next';

const NoRecords = ({ t }) => {
  return (
    <div className="container text-center mt-5 text-black-50">
      <div>
        <FiDatabase size={100} color="#ccc" />
      </div>
      <p className="mt-3">{t('keys.no_entries')}</p>
    </div>
  );
};

export default withTranslation()(NoRecords);
